// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForKPIToolBar = makeThemedStyles('KPIToolBar', () => ({
  KPIToolBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const KPIToolBar: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForKPIToolBar();

  /* eslint-disable */
  return (
    <div {...props} style={{ ...(props?.style || {}), ...{} }} className={clsx(styles.KPIToolBar)}>
      {props?.children}
    </div>
  );
};
export default KPIToolBar;
